var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4433 11.1017C15.2974 11.2757 15.2272 11.373 15.1437 11.4576C12.203 14.436 9.25994 17.412 6.32083 20.392C5.93058 20.787 5.48357 20.9442 4.95377 20.771C4.10625 20.4933 3.81613 19.4447 4.38771 18.7543C4.45709 18.6705 4.53514 18.5939 4.61161 18.5165C7.87238 15.2157 11.1339 11.9149 14.3955 8.61334C15.0798 7.92142 15.7665 7.91743 16.4445 8.60456C19.7203 11.9197 22.9944 15.2365 26.2733 18.5476C26.6573 18.9355 26.8599 19.3656 26.7062 19.9163C26.461 20.7934 25.4187 21.1302 24.7131 20.5611C24.6138 20.4805 24.5255 20.3856 24.4348 20.2946C21.5209 17.3457 18.6063 14.3969 15.6948 11.4457C15.6128 11.3627 15.5544 11.2549 15.4433 11.1017Z",
    fill: "#273239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropUp);
export default __webpack_public_path__ + "static/media/drop-up.d9994ec9136324a60bf842ed0df22d89.svg";
export { ForwardRef as ReactComponent };